function showInformationScreen() {
  window.screenType = "information";
  const currentConsentFileSrc = (window.infosheet_filetype !== null) ? window.infosheet_file : ''

  const text = window.infosheet_text ? window.infosheet_text : ''

  let consentHtml = '';

  if((infosheet_type === "text" && text == "") || (infosheet_type === "file" && window.infosheet_filetype === null)) {
    screen_infosheet="off";
    main();
    return;
  }

  if(infosheet_type === "text" && text.length) { 
    consentHtml = 
      '<div class="form-normal" style="padding-bottom:30px;">' +
          '<label class="col-sm-12 control-label">'+ text + '</label>' +
      '</div>';
  }
  if (infosheet_type !== "text" && currentConsentFileSrc) {
    consentHtml +=
    `
      <div class="form-group withImages">
        <div style="width:100%;">
            <div style="margin-left:1%;margin-right:1%;text-align:center;">
              ${trans("consent.10")} <a style="font-weight:bold; text-decoration:underline;" href="${currentConsentFileSrc}">${trans("consent.11")}</a>
            </div>
        </div>
      </div>
    `
  }

  consentHtml += '<button class="btn btn-primary" type="button" style="font-size:180%;margin-left:auto;margin-right:auto;margin-bottom:20px;display:block;margin-top:30px" onclick="endInformationScreen()">' + textScreens["general"][language]["NEXT"] + '</button>';

  $('#consentQuestionContainer').append(consentHtml);
  $('#consent-title').text(textScreens["consent"][language][6]);
  $('#consentScreen').show();
}

function endInformationScreen() {
  screen_infosheet="off";
  $('#consentQuestionContainer').html('');
  $('#consentScreen').hide();
  window.hideAll();
  main();
}